import { Completion } from '@codemirror/autocomplete'
import { IFlow, INode, JsonSchema, NodeType } from '../definitions/Nodes'
import { IShapeInput } from './NodeManager'

export interface CustomCompletion extends Completion {
    uuid?: string
}

class NodeCodemirrorManagerClass {
    generateCompletionsFromShapes = (shapes: IShapeInput[]): CustomCompletion[] => {
        if (!shapes) return []
        const completitions: CustomCompletion[] = []
        for (const shape of shapes) {
            completitions.push({
                label: shape.nodeName,
                type: 'nodeName',
                info: '-> Node name',
                uuid: shape.nodeUuid
            })
            completitions.push(...NodeCodemirrorManager.generateCompletionsFromShape(shape.shape, shape.nodeName))
        }
        return completitions
    }

    generateCompletionsFromShape = (schema: JsonSchema, prefix: string = ''): CustomCompletion[] => {
        if (!schema) return []
        const completions: CustomCompletion[] = []

        if (schema.type === 'array' && schema.items) {
            completions.push(...NodeCodemirrorManager.generateCompletionsFromShape(schema.items))
        }

        if (schema.type === 'object' && schema.properties) {
            for (const [key, value] of Object.entries(schema.properties)) {
                const fullPath = prefix ? `${prefix}.${key}` : key
                completions.push({
                    label: fullPath,
                    apply: fullPath
                })
                completions.push(...NodeCodemirrorManager.generateCompletionsFromShape(value, fullPath))
            }
        }
        return completions
    }

    changeLabelToUuid = (str: string, keywords: CustomCompletion[], swap: boolean = false): string => {
        let swappedStr = str
        for (const keyword of keywords) {
            const [label] = keyword.label.split('.')
            swappedStr = swap
                ? swappedStr.replaceAll(keyword.uuid, label)
                : swappedStr.replaceAll(label, keyword.uuid)
        }
        return swappedStr
    }

    keywords = <T extends NodeType>(node: INode<T>, flow: IFlow): CustomCompletion[] => {
        return node.inputs.map(i => ({
            label: `${flow.nodes.find(n => n.uuid === i.uuid).name}.${i.outputKey}`,
            type: 'nodeInput',
            apply: `@{${flow.nodes.find(n => n.uuid === i.uuid).name}.${i.outputKey}}`,
            info: '-> Node Input',
            uuid: i.uuid
        }))
    }
}

const NodeCodemirrorManager = new NodeCodemirrorManagerClass()
export default NodeCodemirrorManager
